import '@chillibean/component-library/index.css';

import { ToastNotifications, sizing } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import uuid from 'react-uuid';
import styled from 'styled-components';

import ErrorBoundary from '../FormTemplates/components/container/ErrorBoundary';
import { ChapterDefinitionsContainer } from './components/container';
import { Sidebar } from './components/presentational';
import { setInternal } from './redux/internal.slice';
import setupStore from './redux/store';

export function ChapterDefinitions(props) {
  const { account, planOptions, accountTimezone, authenticityToken } = props;

  const [store] = useState(setupStore());

  useEffect(() => {
    const internalValues = {
      authenticityToken: authenticityToken,
      accountId: account.id,
      accountTimezone: accountTimezone,
      planOptions: planOptions,
    };

    store.dispatch(setInternal(internalValues));
  }, []);

  return (
    <Provider store={store}>
      <Router basename="administration/chapter_definitions">
        <ErrorBoundary authenticityToken={authenticityToken} errorRef={uuid()}>
          <ToastNotifications />
          <Wrapper>
            <Sidebar />
            <ProviderWrapper>
              <ChapterDefinitionsContainer />
            </ProviderWrapper>
          </Wrapper>
        </ErrorBoundary>
      </Router>
    </Provider>
  );
}

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  min-height: 80vh;
`;

const ProviderWrapper = styled.div`
  display: flex;
  width: 80%;
  height: 100%;
  flex-direction: column;
  padding-bottom: ${sizing.large};
`;

ChapterDefinitions.propTypes = {
  authenticityToken: PropTypes.string.isRequired,
  account: PropTypes.shape().isRequired,
  accountTimezone: PropTypes.string.isRequired,
  planOptions: PropTypes.shape().isRequired,
};

export default ChapterDefinitions;
